var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 20,
    viewBox: "0 0 104 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.00012207L12.2451 6.90995H19.5106L13.6327 11.1805L15.8779 18.0903L10 13.8198L4.12215 18.0903L6.36729 11.1805L0.489435 6.90995H7.75486L10 0.00012207Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94 0.00012207L96.2451 6.90995H103.511L97.6327 11.1805L99.8779 18.0903L94 13.8198L88.1221 18.0903L90.3673 11.1805L84.4894 6.90995H91.7549L94 0.00012207Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73 0.00012207L75.2451 6.90995H82.5106L76.6327 11.1805L78.8779 18.0903L73 13.8198L67.1221 18.0903L69.3673 11.1805L63.4894 6.90995H70.7549L73 0.00012207Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52 0.00012207L54.2451 6.90995H61.5106L55.6327 11.1805L57.8779 18.0903L52 13.8198L46.1221 18.0903L48.3673 11.1805L42.4894 6.90995H49.7549L52 0.00012207Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31 0.00012207L33.2451 6.90995H40.5106L34.6327 11.1805L36.8779 18.0903L31 13.8198L25.1221 18.0903L27.3673 11.1805L21.4894 6.90995H28.7549L31 0.00012207Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/Stars.9262090a765fb4fce3986111dd658225.svg";
export { ForwardRef as ReactComponent };